export const isSafariBrowser = () => {
  // ref: https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
  return /Safari/.test(window.navigator.userAgent);
};
